import { ResourceLanguage } from 'i18next'

// Define the shape of your translations, adjust according to your actual structure
interface TranslationResources {
    [key: string]: string | TranslationResources // Example for nested structure
}

export const loadTranslations = () => {
    const files = import.meta.glob('../locales/**/*.json', {
        eager: true,
    })

    return files
}

export const getTranslations = (
    locale: string,
    files: Record<string, unknown>
) => {
    // Filter and process only the files for the given locale
    const translations = Object.keys(files).reduce<Record<string, unknown>>(
        (acc, fileName) => {
            // Check if the file belongs to the specified locale
            if (fileName.startsWith(`../locales/${locale}/`)) {
                const baseName = fileName
                    .replace(`../locales/${locale}/`, '')
                    .replace('.json', '')

                // Assign the JSON content to the corresponding key in the accumulator
                acc[baseName] = (
                    files[fileName] as { default: TranslationResources }
                ).default
            }
            return acc
        },
        {}
    ) as ResourceLanguage

    return translations
}
